import { v4 as uuidv4 } from 'uuid';

const processItemData = [
    {
        id: uuidv4(),
        number: '01',
        heading: 'Discussions About Project',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisic ing elit, sed do eiusmod tempor incididunt',
    },

    {
        id: uuidv4(),
        number: '02',
        heading: 'Start Work With Team',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisic ing elit, sed do eiusmod tempor incididunt',
    },

    {
        id: uuidv4(),
        number: '03',
        heading: 'Handover & Save World',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisic ing elit, sed do eiusmod tempor incididunt',
    },

    {
        id: uuidv4(),
        number: '04',
        heading: 'Great Wall Support',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisic ing elit, sed do eiusmod tempor incididunt',
    },
];

export default processItemData;
